import axios from "axios";

export default {
    namespaced: true,
    state: {
        rbs_stores: [],
        ms_stores: [],

        store_id: null,
        poss: [],
    },
    mutations: {
        unsetLoadedData(state) {
            state.stores = [];
            state.store_id = null;
            state.poss = [];
        },
        unsetLoadedStore(state) {
            state.store_id = null;
            state.poss = [];
        },
        setLoadedStores(state, {rbs_stores, ms_stores}) {
            state.rbs_stores = rbs_stores;
            state.ms_stores = ms_stores;
        },
        setLoadedStore(state, {storeId, poss}) {
            state.store_id = storeId;
            state.poss = poss;
        },
    },
    getters: {
        storeName: (state) => (storeId) => {
            if (storeId.length === 36) return state.ms_stores.find(item => item.id === storeId)?.name ?? storeId;
            else return state.rbs_stores.find(item => item.id === storeId)?.name ?? storeId;
        },
        terminalName: (state) => (terminalId) => {
            if (terminalId.length === 36) return state.ms_stores.flatMap((store) => store.terminals).find(terminal => terminal.id === terminalId)?.name ?? terminalId;
            else return state.poss.find(item => item.id === terminalId)?.name ?? terminalId;
        }
    },
    actions: {
        loadStores({commit, rootState, state}, {rbs_only , force} = {rbs_only: false, force: false}) {
            if ([...state.rbs_stores, ...state.ms_stores].length && !force) {
                if (rbs_only) return Promise.resolve(state.rbs_stores);
                else return Promise.resolve([...state.rbs_stores, ...state.ms_stores]);
            }

            return new Promise(async (resolve, reject) => {
                let rbs_stores = [];
                let ms_stores = [];

                // Load rbs stores
                const rbs_url = rootState.appUrl + '/customer/api/v2/stores?perPage=999';
                rbs_stores.push(...(await axios.get(rbs_url)).data.data);

                // Load ms stores
                ms_stores.push(...(await this.dispatch("organization/loadStores")));

                commit('setLoadedStores', {rbs_stores, ms_stores});
                if (rbs_only) resolve(rbs_stores);
                else resolve([...rbs_stores, ...ms_stores]);
            });
        },
        loadPoss({commit, rootState, state}, {storeId, force} = {storeId: null, force: false}) {
            if (state.store_id === storeId && !force) return Promise.resolve(state.poss);

            commit('unsetLoadedStore');

            // Load ms poss
            if (storeId && storeId.length === 36) {
                return this.dispatch("organization/loadTerminals", storeId).then((poss) => {
                    commit('setLoadedStore', {storeId, poss});
                    return poss;
                });
            }

            // Load rbs poss
            let url = null;
            if (storeId) {
                url = rootState.appUrl + '/customer/api/v2/stores/' + storeId + '/pos';
            } else {
                url = rootState.appUrl + '/customer/api/v2/poss?perPage=999';
            }
            return axios.get(url).then((response) => {
                commit('setLoadedStore', {storeId, poss: response.data.data});
                return response.data.data;
            });
        },
        loadPossAsSelect({commit, rootState}, {storeId, force} = {storeId: null, force: false}) {
            return this.dispatch("store/loadPoss", {storeId, force})
                .then((poss) => {
                    return poss.map(pos => {
                        return {
                            id: pos.id,
                            name: pos.name
                        }
                    })
                });
        }
    },

};
